import { render, staticRenderFns } from "./slider-widget.vue?vue&type=template&id=7f68c674&scoped=true&"
import script from "./slider-widget.vue?vue&type=script&lang=js&"
export * from "./slider-widget.vue?vue&type=script&lang=js&"
import style0 from "./slider-widget.vue?vue&type=style&index=0&id=7f68c674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f68c674",
  null
  
)

export default component.exports